import React from 'react';
import { Link } from 'react-router-dom';

const ServiceSonThanVoPage = () => {
    return (
        <main className="product-category" style={{ borderBottom: '1px solid #ececec', paddingBottom: 20 }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4 text-left">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item">
                                <Link to="/dich-vu" className="hover:text-red-600 transition-colors no-underline text-slate-500">Dịch vụ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Sơn & Thân Vỏ
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="heading-primary text-center" style={{ margin: '60px 0' }}>
                    <span>Sơn Phục Hồi &amp; Nâng Cấp Thân Vỏ</span>
                </h1>
                <p className="text-center">
                    Bạn có thể bổ sung nội dung chi tiết về sơn dặm, sơn quây, sơn đổi màu, phục hồi thân vỏ... tại đây.
                    Layout đã sẵn sàng để mở rộng giống các trang danh mục khác.
                </p>
            </div>
        </main>
    );
};

export default ServiceSonThanVoPage;




